/* eslint-disable no-empty-pattern */
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, InputAdornment, Menu, MenuItem, Tooltip } from '@material-ui/core';
import { Visibility } from '@material-ui/icons';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import FilterListIcon from '@material-ui/icons/FilterList';
import FindReplaceOutlinedIcon from '@material-ui/icons/FindReplaceOutlined';
import React, { useCallback, useEffect, useState } from 'react';
import { isBaseURLAll } from '../../../api/utils';
import ReactAGGrid from '../../commons/ReactAGGrid';
import { ButtonWrapper } from '../FilterSort.Styles';
import { CustomTextField, GridWrapper, TitleWrapper, Wrapper } from './FilterTable.Styles';
import { FilterValidationResult } from '../../commons/FilterValidationResult';
export var FilterTable = function (_a) {
    var filterData = _a.filterData, deleteRow = _a.deleteRow, viewRow = _a.viewRow, handleOnRowEdit = _a.handleOnRowEdit, openBar = _a.openBar, contactLists = _a.contactLists;
    var _b = useState(filterData), rows = _b[0], setRows = _b[1];
    var _c = useState(null), filterAnchor = _c[0], setFilterAnchor = _c[1];
    var _d = useState('Filter/Sort Name'), filterName = _d[0], setFilterName = _d[1];
    var _e = useState(''), filterTarget = _e[0], setFilterTarget = _e[1];
    var _f = useState(''), contactListValidate = _f[0], setContactListValidate = _f[1];
    var _g = useState(false), validateOpen = _g[0], setValidateOpen = _g[1];
    var _h = useState(false), openAlert = _h[0], setOpenAlert = _h[1];
    var _j = useState(false), openValidationResult = _j[0], setOpenValidationResult = _j[1];
    var _k = useState([]), selectedFilters = _k[0], setSelectedFilters = _k[1];
    useEffect(function () {
        setRows(filterData);
    }, [filterData]);
    var columns = [
        {
            headerName: 'Account Name',
            field: 'prjacc.name',
            hide: !isBaseURLAll(),
            width: 200
        },
        {
            field: 'filterName',
            headerName: 'Filter Name',
            checkboxSelection: validateOpen,
            headerCheckboxSelection: validateOpen,
            showDisabledCheckboxes: true
            // renderCell: ({ row }) => {
            //   return <MultilineText>{row?.filterName}</MultilineText>;
            // },
        },
        {
            field: 'filterType',
            headerName: 'Filter Type'
        },
        {
            field: 'tableCL',
            headerName: 'Contact List'
        },
        {
            field: 'filterOrSort',
            headerName: 'Filter/Sort'
        },
        {
            field: 'filterSQL',
            headerName: 'SQL Filter'
        },
    ];
    var handleFilterMenu = function (event) {
        setFilterAnchor(event.currentTarget);
    };
    var handleCloseFilter = function () {
        setFilterAnchor(null);
    };
    var filteredRow = function (filterMode) {
        var lowerTarget = filterTarget.toLowerCase();
        switch (filterMode) {
            case 'Filter/Sort Name':
                return rows.filter(function (row) {
                    var _a;
                    return ((_a = row.filterName) === null || _a === void 0 ? void 0 : _a.toLowerCase().indexOf(lowerTarget)) !== -1;
                });
            case 'Contact List Name':
                return rows.filter(function (row) {
                    var _a;
                    return ((_a = row.tableCL) === null || _a === void 0 ? void 0 : _a.toLowerCase().indexOf(lowerTarget)) !== -1;
                });
            default:
                return rows;
        }
    };
    var isRowSelectable = useCallback(function (params) {
        return (params.data.tableCL === contactListValidate || contactListValidate === '') && validateOpen;
    }, [contactListValidate, validateOpen]);
    return (React.createElement(Wrapper, null,
        React.createElement(TitleWrapper, null,
            ' ',
            React.createElement(ButtonWrapper, null,
                React.createElement(CustomTextField, { size: 'small', label: "Filter by " + filterName, placeholder: "Filter by " + filterName, variant: 'outlined', InputProps: {
                        endAdornment: (React.createElement(InputAdornment, { position: 'end' },
                            React.createElement(Tooltip, { title: 'Change Filter Criteria', placement: 'top' },
                                React.createElement(IconButton, { onClick: handleFilterMenu },
                                    React.createElement(FilterListIcon, null)))))
                    }, onChange: function (e) { return setFilterTarget(e.target.value); } }),
                React.createElement(Menu, { id: 'filter-menu', open: Boolean(filterAnchor), keepMounted: true, anchorEl: filterAnchor, onClose: handleCloseFilter },
                    React.createElement(MenuItem, { onClick: function () {
                            handleCloseFilter();
                            setFilterName('Filter/Sort Name');
                        } },
                        "Filter/Sort Name",
                        ' '),
                    React.createElement(MenuItem, { onClick: function () {
                            handleCloseFilter();
                            setFilterName('Contact List Name');
                        } }, "Contact List Name")))),
        React.createElement(GridWrapper, null,
            React.createElement(ReactAGGrid, { name: 'filter', columns: columns, onRowClicked: function (e) { }, rows: filteredRow(filterName), rowSelection: validateOpen ? 'multiple' : undefined, isRowSelectable: isRowSelectable, selectAllOnIsRowSelectableChange: true, onSelectionChanged: function (event) {
                    console.log('ghiaha', event, event.api.getSelectedRows());
                    setSelectedFilters(event.api.getSelectedRows());
                }, actions: [
                    {
                        icon: function () { return React.createElement(EditOutlinedIcon, null); },
                        tooltip: 'Edit User',
                        disabled: openBar,
                        onClick: function (event, rowData) {
                            handleOnRowEdit(rowData, true);
                        }
                    },
                    {
                        icon: function () { return React.createElement(FindReplaceOutlinedIcon, null); },
                        tooltip: 'Copy',
                        disabled: openBar,
                        onClick: function (event, rowData) {
                            handleOnRowEdit(rowData, false);
                        }
                    },
                    {
                        icon: function () { return React.createElement(Visibility, null); },
                        tooltip: 'View',
                        disabled: openBar,
                        onClick: function (event, rowData) {
                            viewRow(rowData);
                        }
                    },
                    {
                        icon: function () { return React.createElement(DeleteOutlineOutlinedIcon, null); },
                        tooltip: 'Delete',
                        disabled: openBar,
                        onClick: function (event, rowData) {
                            deleteRow(rowData.id);
                        }
                    },
                ] })),
        React.createElement(Dialog, { open: openAlert, onClose: function () { return setOpenAlert(false); }, "aria-labelledby": 'alert-delete', "aria-describedby": 'alert-dialog-description' },
            React.createElement(DialogTitle, { id: 'alert-delete' }, "Validate Filters"),
            React.createElement(DialogContent, null,
                React.createElement(DialogContentText, { id: 'alert-dialog-description' }, "Validation request can take up to 10 mins. Are you sure you want to proceed?")),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: function () { return setOpenAlert(false); }, color: 'primary' }, "Cancel"),
                React.createElement(Button, { onClick: function () {
                        setOpenAlert(false);
                        setOpenValidationResult(true);
                    }, color: 'primary', autoFocus: true }, "Proceed"))),
        React.createElement(FilterValidationResult, { title: 'Validate Filter', open: openValidationResult, onClose: function () { return setOpenValidationResult(false); }, data: {} })));
};
FilterTable.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=FilterTable.js.map